var map = {
	"./accounts.js": "260b",
	"./audits.js": "ed58",
	"./auth.js": "11c0",
	"./authfack.js": "8dd5",
	"./budget.js": "f558",
	"./bulksms.js": "7bb8",
	"./classes.js": "0618",
	"./coursework.js": "8fc0",
	"./dashboard.js": "d959",
	"./expenses.js": "f18a",
	"./fees.js": "6ddf",
	"./grades.js": "afae",
	"./inventory.js": "42d8",
	"./layout.js": "c21a",
	"./marks.js": "253e",
	"./modes.js": "4410",
	"./notification.js": "2208",
	"./pettycash.js": "fd62",
	"./revenues.js": "8da8",
	"./school.js": "4cc4",
	"./settings.js": "77bc",
	"./staff.js": "f917",
	"./students.js": "3404",
	"./todo.js": "3747",
	"./transport.js": "f8b1",
	"./users.js": "b20d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";